export default __webpack_public_path__ + "static/char-v-16-c70d5c8c9749837c5c77737c63001c2b.png";